import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { useAuth } from "@qure/qure-auth";
import { useSelectedPatientStore } from "@/stores/selected-patient";
import { useTaskDetailStore } from "@/stores/task-detail";
import { usePatientTasksStore } from "@/stores/patient-tasks";
import { TaskSection } from "./task-section";
import { TasksSkeleton } from "./tasks-skeleton";
import { CreateTask } from "./create-task";
import { useSuggestedActionsStore } from "@/stores/suggested-actions";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Right panel listing the patient's tasks grouped by ownership and completion. */
export function PatientTasks(_ref) {
  var _selectedPatient$remi, _userInfo$details;
  var _ref$onAddNewReminder = _ref.onAddNewReminder,
    onAddNewReminder = _ref$onAddNewReminder === void 0 ? function () {} : _ref$onAddNewReminder;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isCreatingTask = usePatientTasksStore(function (s) {
    return s.isCreating;
  });
  var prefillState = usePatientTasksStore(function (s) {
    return s.prefillState;
  });
  var startCreate = usePatientTasksStore(function (s) {
    return s.startCreate;
  });
  var stopCreate = usePatientTasksStore(function (s) {
    return s.stopCreate;
  });
  var open = useTaskDetailStore(function (s) {
    return s.open;
  });
  var selectedPatient = useSelectedPatientStore(function (s) {
    return s.selectedPatient;
  });
  var selectedNextStep = useSuggestedActionsStore(function (s) {
    return s.selectedNextStep;
  });
  var setSelectedNextStep = useSuggestedActionsStore(function (s) {
    return s.setSelectedNextStep;
  });
  useEffect(function () {
    var _selectedNextStep$dis, _action$context, _action$remind_after;
    if (!selectedNextStep || selectedNextStep.type !== "reminder") return;
    var action = selectedNextStep.action;
    startCreate(_objectSpread({
      title: (_selectedNextStep$dis = selectedNextStep.display_name) !== null && _selectedNextStep$dis !== void 0 ? _selectedNextStep$dis : "",
      context: (_action$context = action === null || action === void 0 ? void 0 : action.context) !== null && _action$context !== void 0 ? _action$context : "",
      remindAfter: (_action$remind_after = action === null || action === void 0 ? void 0 : action.remind_after) !== null && _action$remind_after !== void 0 ? _action$remind_after : ""
    }, action !== null && action !== void 0 && action.appointmentId ? {
      linkedResources: {
        reports: [],
        appointments: [action.appointmentId],
        encounters: []
      }
    } : {}));
    setSelectedNextStep(null);
  }, [selectedNextStep, setSelectedNextStep]);
  var isLoading = !selectedPatient;
  var reminders = (_selectedPatient$remi = selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient.reminders) !== null && _selectedPatient$remi !== void 0 ? _selectedPatient$remi : [];
  if (isCreatingTask) {
    return /*#__PURE__*/React.createElement(CreateTask, {
      prefillState: prefillState,
      onCancel: function onCancel() {
        return stopCreate();
      },
      onSuccess: function onSuccess() {
        onAddNewReminder();
        stopCreate();
      }
    });
  }
  var sorted = _toConsumableArray(reminders).sort(function (a, b) {
    return new Date(a.remind_after).getTime() - new Date(b.remind_after).getTime();
  });
  var currentUserEmail = userInfo === null || userInfo === void 0 || (_userInfo$details = userInfo.details) === null || _userInfo$details === void 0 ? void 0 : _userInfo$details.email;
  var completed = sorted.filter(function (r) {
    return r.resolved;
  });
  var myTasks = sorted.filter(function (r) {
    var _r$owned_by_info;
    return !r.resolved && ((_r$owned_by_info = r.owned_by_info) === null || _r$owned_by_info === void 0 ? void 0 : _r$owned_by_info.email) === currentUserEmail;
  });
  var otherTasks = sorted.filter(function (r) {
    var _r$owned_by_info2;
    return !r.resolved && ((_r$owned_by_info2 = r.owned_by_info) === null || _r$owned_by_info2 === void 0 ? void 0 : _r$owned_by_info2.email) !== currentUserEmail;
  });
  return /*#__PURE__*/React.createElement("aside", {
    className: "h-full flex flex-col bg-sds-base-default overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-4 py-3 flex-shrink-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-tertiary"
  }, t("tasks")), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "patient-tasks-add",
    "aria-label": t("add_task"),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.PATIENT_TASKS_ADD);
      startCreate();
    },
    className: "w-6 h-6 flex items-center justify-center rounded-sds-100 text-sds-base-secondary hover:bg-sds-base-secondary hover:text-sds-base-default transition-colors border border-sds-base-default"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPlus,
    className: "w-3.5 h-3.5"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 overflow-y-auto scrollbar-sds px-4 py-4"
  }, isLoading ? /*#__PURE__*/React.createElement(TasksSkeleton, null) : sorted.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center h-full gap-3"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faBell,
    className: "w-8 h-8 text-sds-base-tertiary"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-tertiary"
  }, t("no_reminders_set"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TaskSection, {
    title: t("label.my_tasks"),
    count: myTasks.length,
    emptyMessage: t("message.no_my_tasks"),
    reminders: myTasks,
    onSelect: open
  }), /*#__PURE__*/React.createElement(TaskSection, {
    title: t("label.other_tasks"),
    count: otherTasks.length,
    emptyMessage: t("message.no_tasks"),
    reminders: otherTasks,
    onSelect: open
  }), /*#__PURE__*/React.createElement(TaskSection, {
    title: t("label.completed"),
    count: completed.length,
    emptyMessage: t("message.no_completed_tasks"),
    reminders: completed,
    onSelect: open
  }))));
}